import { Component, OnInit } from "@angular/core";
import { CommonService } from "@core/services/common.service";
import { BaseModuleComponent } from "@modules/base-module/base-module.component";

@Component({
    selector: 'app-insured-trips',
    template: ``,
    styleUrls: [],
    standalone: false
})
export class InsuredTripsBaseComponent extends BaseModuleComponent implements OnInit {

    constructor(
        public commonService: CommonService,
    ) {
        super(commonService);
    }

    ngOnInit(): void {

    }

    // DRY ma insurance
    protected moduleNameByTarrif(tarrifName: string): string {
        if(tarrifName.includes('LN')){
            return 'Liečebné náklady';
        }

        if(tarrifName.includes('SB')){
            return 'Standard Business';
        }

        if(tarrifName.includes('OB')){
            return 'Optimal Business';
        }

        if(tarrifName.includes('B') || tarrifName.includes('BB')){
            return 'Basic Business';
        }

        return tarrifName;
    }
}
